"use strict";

var _slicedToArray = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DATA_FIELD_TYPE;

(function (DATA_FIELD_TYPE) {
  DATA_FIELD_TYPE["INTEGER"] = "integer";
  DATA_FIELD_TYPE["BOOLEAN"] = "boolean";
  DATA_FIELD_TYPE["STRING"] = "string";
  DATA_FIELD_TYPE["BINARY"] = "binary";
})(DATA_FIELD_TYPE = exports.DATA_FIELD_TYPE || (exports.DATA_FIELD_TYPE = {}));

function anyOf(items, options) {
  return new AnyOfClass(items, options);
}

exports.anyOf = anyOf;

var AnyOfClass =
/*#__PURE__*/
function () {
  function AnyOfClass(_items, options) {
    _classCallCheck(this, AnyOfClass);

    this._items = _items;
    this.type = 'anyOf';
    this.discriminatorField = 'type';
    this.discriminatorBytePos = 0; // defaults to 0

    Object.assign(this, options);
  }

  _createClass(AnyOfClass, [{
    key: "itemByKey",
    value: function itemByKey(k) {
      // Here if k equals undefined (this happens if discriminator field is undefined), first item with no string key returns
      // This is useful for items without versions. E.g. orderV0
      var row = this._items.find(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 3),
            key = _ref2[0],
            schema = _ref2[1],
            stringKey = _ref2[2];

        return stringKey === k || key == k;
      });

      return row && {
        schema: row[1],
        key: row[0],
        strKey: row[2]
      };
    }
  }, {
    key: "itemByByteKey",
    value: function itemByByteKey(k) {
      var row = this._items.find(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            _ = _ref4[1];

        return key === k;
      });

      return row && {
        schema: row[1],
        key: row[0],
        strKey: row[2] || row[0].toString(10)
      };
    }
  }]);

  return AnyOfClass;
}();